import type { EventType } from "app/types/eventType";
import { EventStatus } from "app/utils/const";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import MarketPeriods from "./components/MarketPeriods/MarketPeriods";
import "./ModalMarkets.scss";
type Props = {
  event: EventType;
};
type State = {
  isActive: boolean;
}; //

class ModalMarkets extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      isActive: true,
    };
  }

  render() {
    const { event } = this.props;
    const numberOfMarkets = event["numberOfMarkets"];
    return (
      <div
        className={`unsummarized-markets-modal__markets ${
          event.competition && event.competition.live === true
            ? "live"
            : "dead-ball"
        } ${
          event !== undefined && event.status ? event.status.toLowerCase() : ""
        }`}
      >
        {/* map through market periods summary */}
        {event !== undefined && event.status === EventStatus.SUSPENDED && (
          <div className="suspended__text--event">{event.status}</div>
        )}
        {event !== undefined &&
          (event.status === EventStatus.GRADED ||
            event.status === EventStatus.CLOSED) && (
            <div className="suspended__text--event">
              <FormattedMessage tagName="span" id={"events-eventclosed"} />
            </div>
          )}
        {/* To handle case when prices drop after goal, event goes live etc */}
        {event.status === EventStatus.OPEN && numberOfMarkets === 0 && (
          <div className="asian-event__no-odds">
            <FormattedMessage
              tagName="span"
              id={"events-no-odds"}
              className="no-odds-available"
            />
          </div>
        )}

        {event.marketPeriods != null &&
          event.marketPeriods.map((marketPeriod, index) => {
            return (
              <MarketPeriods
                key={index}
                event={event}
                marketPeriod={marketPeriod}
                className={`market-period-summary`}
              />
            );
          })}
      </div>
    );
  }
}

export default ModalMarkets;
